import {Injectable} from '@angular/core';
import {ConnectorService} from './connector.service';
import {Observable} from 'rxjs';
import {ITaskGraphStat} from '../../models/graph.model';

@Injectable({
    providedIn: 'root',
})
export class CrmGraphService extends ConnectorService {
    /**
     * Получение статистики по конкретной задачи для построения графа
     * @param task_alias уникальный код задачи
     */
    getGraphTaskStat(task_alias: string): Observable<ITaskGraphStat> {
        return this.get('instance/crm/task/graph/' + task_alias);
    }
}